import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { ApiPartnerService } from '../../api/api-partner.service';
import { FormGroup, FormControl, FormBuilder, NgForm, Validators } from '@angular/forms';
import { LoadJsService } from '../../load-js/load-js.service';

@Component({
  selector: 'app-order-view',
  templateUrl: './order-view.component.html',
  styleUrls: ['./listorder.component.css']
})
export class OrderviewComponent implements OnInit {

  

  images = [];
   myForm = new FormGroup({
    name: new FormControl('', [Validators.required, Validators.minLength(3)]),
    file: new FormControl('', [Validators.required]),
    fileSource: new FormControl('', [Validators.required])
  });

  ViewCustomer: any = [];
  ViewDetOrder: any = [];
  actionHistory: any = [];
  listservices: any = [];
  liststb: any = [];
  liststbcust: any = [];
  listfactoryreset: any = [];
  alert_act='';

  alert_failed = false
  alert_success = false
  purchaseorder_id;


  fileData:File = null
  previewUrl:any = null
  image:any
  identity_imagex : any;

  formReset = this.fb.group({
    email: [''],
    note: [''],
  })

  constructor(
	  private route: ActivatedRoute,
    private fb: FormBuilder,
    public LoadJsOrder: LoadJsService,
	  private router: Router,
	  public partnerService: ApiPartnerService
  ) { }

  get f(){
    return this.myForm.controls;
  }
  
  ngOnInit() {
  	this.loadStart();

  }

  _file : File;
  /* upload */
  onFileChange(event) {
  
    if (event.target.files.length > 0) {
      //const file = event.target.files[0];
      const file:File = event.target.files[0];
      console.log(file);
      //this._file = file;
      this.myForm.patchValue({
        fileSource: file
      });
    }
  }
   




  changeBase64($event:any) {
    this.fileData = <File>$event.target.files[0]
    this.preview()
    this.readThis($event.target)

    // setTimeout(() => {
    //   this.uploadtest()
    // }, 5000);
  }
  preview() {
    // Show preview 
    var mimeType = this.fileData.type;
    if (mimeType.match(/image\/*/) == null) {
      return;
    }

    var reader = new FileReader();      
    reader.readAsDataURL(this.fileData); 
    reader.onload = (_event) => { 
      this.previewUrl = reader.result; 
    }
  }
  readThis(inputValue: any): void {
    var file:File = inputValue.files[0];
    var myReader:FileReader = new FileReader();

    myReader.readAsDataURL(file);
    myReader.onloadend = (e) => {
      this.image = myReader.result;
      // console.log(this.image)
    }
  }

  imgpreview(){
    console.log(this.myForm.get('fileSource').value.name);
    return this.myForm.get('fileSource').value.name;
  }
  submitimg(){
      const formData = new FormData();
    //console.log(this._file);
    // formData.append('file', this.image);
    // formData.append('purchaseorder_id', '12123');
    // console.log(formData);
    formData.append('file_upload', this.myForm.get('fileSource').value);
    formData.append('purchaseorder_id', this.purchaseorder_id);
    //formData.append('attach_id', '121334');
   let data = {'file' : this.image,'purchaseorder_id':this.purchaseorder_id};
   this.partnerService.PostUploadFileResi(formData)
      .subscribe((output: any) => {
        console.log(output);
         this.loadOrder(this.purchaseorder_id);
        
      }
    );

   // this.partnerService.PostUploadFileResi(data)
   //    .subscribe((output: any) => {
   //      console.log(output)
        
   //    }
   //  );

      
  }

  fileexist(){
    if ( this.ViewDetOrder.file ){
      return true;
    }else{
      return false;
    }
  }
  publicfile(){
    var re = "http://192.168.177.187/"; 
    var str = this.ViewDetOrder.file.filename;
    return str.replace(re, "https://dinosaurus.mncvision.id:8484/"); 
  }
  submit(){
    const formData = new FormData();
    //console.log(this._file);
    formData.append('file', this.myForm.get('fileSource').value);
    formData.append('purchaseorder_id', '12123');
    console.log(formData);
    //formData.append('file_upload', this.myForm.get('fileSource').value);
    //formData.append('purchaseorder_id', '121334');
    //formData.append('attach_id', '121334');
   
    this.partnerService.PostUploadFileResi(formData)
      .subscribe((output: any) => {
        console.log(output)
        this.loadOrder(this.purchaseorder_id);
        
      }
    );

    // this.http.post('http://localhost:8001/upload.php', formData)
    //   .subscribe(res => {
    //     console.log(res);
    //     alert('Uploaded Successfully.');
    //   });
  }
  /* end  upload */


  loadStart() {
    let id = this.route.snapshot.paramMap.get('id');
  	//alert(id);
    this.purchaseorder_id = id;
    this.loadOrder(id);
    //this.loadDetailreset(id)
  }

  loadOrder(id: any) {
    return this.partnerService.GetViewPlayboxOrder(id).subscribe((output: any) => {
    console.log(output);
       //this.ViewCustomer = output.data;
       this.ViewDetOrder = output['data'];
       console.log(this.ViewDetOrder);
       
    })
  }
  loadCustomer(id: any) {
    return this.partnerService.GetViewCustomer(id).subscribe((output: any) => {
    console.log(output);
       this.ViewCustomer = output.data;
       this.listservices = output.data.services;
       this.liststb = output.data.stb;
       this.liststbcust = output.data.stbcust;
       this.actionHistory = output.data.actionHistory;
    })
  }

  loadDetailreset(id: any) {
    return this.partnerService.GetListcustfactoryreset(id).subscribe((output: any) => {
    console.log(output);
       this.listfactoryreset = output.data;
    })
  }

  onActionClick(act:any, item: any)
  {
    this.alert_act = act;
    console.log(act);
    this.formReset.reset()

    // if ( act == "setkondisi" || act == "approve") {
    //   this.formApprove.reset()
    //   this.itemstb = item
    // }
  }

  submitreset(item:any, el: HTMLElement) {
    this.partnerService.PostCustfactoryreset(item.id, this.formReset.value)
      .subscribe((output: any) => {
        console.log(output)
        if ( output.status ){
          this.loadStart()
          this.LoadJsOrder.loadScriptProductStb()
          this.alert_success = true
  
          setTimeout(()=>{
            el.scrollIntoView({behavior:"smooth"})
          }, 500);
          setTimeout(()=>{
            this.alert_success = false
          }, 6000);
          
        } else {
          this.LoadJsOrder.loadScriptProductStb()
          this.alert_failed = true
          setTimeout(()=>{
            this.alert_failed = false
          }, 6000);
        }
      }
    )
  }

  showcustomer(field){
    if (this.ViewDetOrder.customer == undefined){
      return '';
    }else{
      return this.ViewDetOrder.customer[field];
    }
  }

  isfile (){
    if ( this.ViewDetOrder.file ){
      return true;
    }else{
      return false;
    }
  }

}

